<template>
  <div ref="container" class="mail-view p-15" id="mail-view" :class="colClass" role="main">
    <!-- Email here -->
    <div
      v-if="currentEmail"
      :style="{ height: emailHeight, marginRight: emailMarginRight }"
      style="transition: all 350ms cubic-bezier(0.19, 1, 0.22, 1)"
      ref="email"
      class="email p-15"
    >
      <div class="row">
        <div class="col-md-12">
          <template v-if="versionTemplateKey == 2">
            <h2 class="m-10 text-light">
              Question #{{ $store.state.selectedQuestionID }}
              <br />
              <small
                v-if="
                  $store.state.versionConfig &&
                  $store.state.versionConfig.assessmentHideCompetencyDisplay != true
                "
                >{{ currentEmail.competencyName }}</small
              >
            </h2>
            <br />
          </template>
          <template v-else>
            <h2 class="m-10 text-light">
              {{ currentEmail.subjectTagKey }}
            </h2>
          </template>
        </div>
      </div>
      <template v-if="versionTemplateKey !== 2">
        <div class="media mb-25">
          <div class="media-left">
            <authorInitial
              :author-name="currentEmail.authorNameTagKey"
              :theme-key="currentEmail.authorThemeKey"
            ></authorInitial>
          </div>
          <div class="media-body">
            <h4 class="text-semibold mt-0">
              {{ currentEmail.authorNameTagKey }} <br /><small class="author-title">{{
                currentEmail.authorTitle
              }}</small>
            </h4>
            {{ currentEmail.timestamp }}
          </div>
        </div>
        <template v-if="currentEmail.isSent">
          <div class="row">
            <div class="col-md-12 text-center">
              <div class="alert alert-success text-black" role="alert">
                You replied to this email.
              </div>
            </div>
          </div>
        </template>
      </template>

      <template v-for="file in currentEmail.files">
        <div
          @click="openFile(file)"
          :key="`file-${file.fileKey}`"
          data-toggle="modal"
          data-target="#myModal"
          class="btn btn-default btn-sm mb-15 mr-15"
        >
          <span :class="['glyphicon', 'p-5', getFileIcon(file)]"></span>
          <span>{{ file.displayName }}</span>
          <span class="glyphicon glyphicon-triangle-bottom" style="font-size: 0.7em"></span>
        </div>
      </template>

      <div class="row">
        <div v-html="emailDescription" class="col-md-12 pl-20 pr-20 mb-20"></div>
        <mail-signature
          v-if="!(versionTemplateKey === 2) && isBizCardEnabled"
          :question="currentEmail"
        ></mail-signature>
      </div>
      <div
        v-if="currentEmail.FK_questionDisplayTypeKey === 3 && currentEmail.feedback"
        :style="`background-color: #e6f2ff; padding: 10px 5px 5px 10px; margin:5px 0px 10px 5px`"
      >
        <span
          v-html="currentEmail.feedback.replace(/<p>/, `<p><strong>Feedback:</strong> &nbsp`)"
        ></span>
      </div>
      <template v-if="showAnswers">
        <template v-if="versionTemplateKey == 2">
          <modx-answers :current-email="currentEmail" :info="info" />
        </template>
        <template v-else>
          <inbox-answers
            :current-email="currentEmail"
            :info="info"
            :key="currentEmail.questionKey"
          />
        </template>
      </template>

      <template v-if="versionTemplateKey == 2">
        <button
          class="btn btn-primary pull-left mat"
          v-if="showPrevious"
          id="showPrevious"
          @click="clickPrevious"
        >
          Previous
        </button>
        <button
          class="btn btn-primary pull-right mat"
          v-if="showNext"
          id="showNext"
          @click="clickNext"
        >
          Next
        </button>
      </template>
    </div>
    <!-- No email selected -->
    <div class="empty"></div>
  </div>
</template>
<script>
  import radioButton from '../inputs/radio.vue';
  import authorInitial from '@shared/AuthorInitial.vue';
  import mailSignature from '../MailSignature.vue';
  import InboxAnswers from './InboxAnswers';
  import ModxAnswers from './ModxAnswers';
  import { mapGetters, mapState } from 'vuex';

  export default {
    name: 'mailView',

    components: {
      radioButton,
      authorInitial,
      mailSignature,
      InboxAnswers,
      ModxAnswers,
    },

    data() {
      return {
        windowHeight: 0,
        size: 7,
        isChatOpen: false,
        errorMessage: 'Please pick an answer.',
        smartAnswer: null,
      };
    },

    props: {
      currentEmail: {
        type: Object,
      },
      questionNumber: {
        type: [Number, String],
      },
      className: {
        type: String,
      },
    },

    watch: {
      'currentEmail.questionKey': function () {
        if (this.$refs.email) this.scrollTop();
      },
    },

    computed: {
      ...mapState(['versionTemplateKey']),
      showAnswers() {
        return (
          this.currentEmail.answers.length > 0 ||
          this.currentEmail.isWrittenResponse === 1 ||
          this.currentEmail.FK_questionTypeKey === 3
        );
      },
      emailDescription() {
        let description = this.currentEmail.descriptionTagKey
          .replace(/{name}/g, this.userName)
          .replace(/{date.\(-\d{0,2}\)}/g, (match) => this.formatDate(match, 'MMMM D, YYYY'))
          .replace(
            /{date}/g,
            this.$dayjs().startOf('week').subtract(2, 'day').format('MMMM D, YYYY')
          )
          .replace(/{datetime.\(-\d{0,2}\)}/g, (match) =>
            this.formatDate(match, 'MMMM D, YYYY h:mm a')
          )
          .replace(
            /{datetime}/g,
            this.$dayjs().startOf('week').subtract(2, 'day').format('MMMM D, YYYY h:mm a')
          );

        return description;
      },

      emailHeight() {
        if (this.currentEmail) {
          if (this.versionTemplateKey == 2) {
            return `${this.windowHeight - 200}px`;
          } else {
            return `${this.$refs.container.offsetHeight - 30}px`;
          }
        }
      },

      authorFirstName() {
        return this.currentEmail.authorNameTagKey.split(' ')[0];
      },

      isBizCardEnabled() {
        return this.$store.state.role.enableBizCard;
      },

      writtenResponse: {
        get: function () {
          return this.currentEmail.writtenResponse || '';
        },

        set: function (value) {
          this.$store.commit('email/SET_WRITTEN_REPONSE', {
            questionKey: this.currentEmail.questionKey,
            writtenResponse: value,
          });
        },
      },

      emailMarginRight() {
        return this.isChatOpen ? `${this.$store.getters.constants['chat-width']}px` : '0px';
      },

      colSize() {
        var arr = this.size.toString().split('.');
        return arr.length > 1 ? `${arr[0]}${arr[1]}` : `${arr[0]}`;
      },

      colClass() {
        if (this.className) return this.className;
        return `col-md-${this.colSize}`;
      },

      answered() {
        return this.currentEmail.answer !== undefined;
      },

      userName() {
        return this.$store.state.userData.firstname;
      },

      info() {
        if (this.$store.state) {
          // startCase
          return this.$store.state.info;
        }
      },

      showPrevious() {
        return this.$store.state.selectedQuestionID > 1;
      },

      showNext() {
        return (
          this.$store.state.selectedQuestionID < this.$store.getters['email/activeEmails'].length
        );
      },
    },

    methods: {
      clickPrevious() {
        $(`#questionListTable tr:nth-child(${this.$store.state.selectedQuestionID - 1})`).click();
      },

      clickNext() {
        $(`#questionListTable tr:nth-child(${this.$store.state.selectedQuestionID + 1})`).click();
      },

      formatDate(match, format) {
        let offset = parseInt(match.substring(8, match.length - 2));
        return this.$dayjs()
          .startOf('week')
          .subtract(2 + offset, 'day')
          .format(format);
      },

      resize() {
        this.$el.style.height = `${window.innerHeight - 50}px`;
        if (this.$refs.email)
          this.$refs.email.style.height = `${this.$refs.container.offsetHeight - 30}px`;

        this.windowHeight = window.innerHeight;
      },

      scrollTop() {
        this.$refs.email.scrollTop = 0;
      },

      openFile(file) {
        this.$emit('openFile', file);
      },

      getFileIcon(file) {
        let docType = file.FK_fileTypeKey;
        switch (docType) {
          case 1:
            return 'glyphicon-picture';
          case 2:
            return 'glyphicon-play-circle';
          default:
            return 'glyphicon-file';
        }
      },
    },

    mounted() {
      this.windowHeight = window.innerHeight;
      EventBus.$on('open', () => (this.size -= 1.5));
      EventBus.$on('close', () => (this.size += 1.5));
      $(window).on('resize', () => this.resize());
      EventBus.$on('toggleChat', () => (this.isChatOpen = !this.isChatOpen));
    },
  };
</script>
<style lang="scss" scoped>
  .text-black {
    color: black;
    font-weight: 500;
  }
  .mail-view {
    background-color: #fafafa;
    color: #6c6d6d;
    height: 100%;

    &.modex {
      background-color: #edeff0;
      padding: 60px !important;
    }
    .email {
      overflow-y: auto;
      background-color: white;
      box-shadow: 0px 0px 2px rgba(181, 181, 181, 0.45);
      border-radius: 2px;
      color: black;
    }

    .author-title {
      font-size: 1.2rem;
      color: #000;
    }

    > h3 {
      line-height: 60px;
      margin: 0 -15px;
      color: white;
      background-color: #41cac0;
    }

    .mail-buttons {
      color: #6c6d6d;

      .glyphicon {
        font-size: 18px;
      }
      .icon-text {
        font-size: 16px;
        text-transform: uppercase;
      }
    }

    .emailMsgAnswer {
      width: 100%;
      margin-bottom: 20px;
    }

    .glyphicon-share-alt {
      &.Reply {
        transform: scaleX(-1);
      }
      &.Forward {
        transform: scaleY(1);
      }
    }

    .flagged {
      color: #ff4d4d;
      text-shadow: 0 0 1px rgba(0, 0, 0, 0.52);
    }

    .questions {
      counter-reset: listStyle;
      .answer-choice {
        counter-increment: listStyle;
        margin-left: 20px;
      }
      .answer-choice::before {
        position: absolute;
        left: -20px;
        top: 5px;
        content: counter(listStyle, upper-alpha) '.';
      }

      .error-message {
        color: red;
      }

      label {
        font-weight: normal;
        .glyphicon {
          font-size: 14px;
        }
        .unchecked-answer {
          padding-top: 1px;
          width: 13px;
          height: 13px;
          border: 2px solid black;
          border-radius: 50%;
          display: inline-block;
        }
      }
    }
  }
</style>
